export default __webpack_public_path__ + "static/water_texture-fdaa36657b35853ab5ec77e94c381017.webp";